import { createContext, useContext } from 'react';
import { useProfiles } from '../hooks/useProfiles';

type ProfilesContextType = ReturnType<typeof useProfiles>;

export const ProfilesContext = createContext<ProfilesContextType | undefined>(undefined);

export const useProfilesContext = () => {
  const context = useContext(ProfilesContext);
  if (!context) {
    throw new Error('useProfilesContext must be used within ProfilesProvider');
  }
  return context;
};
